import React, { ComponentType, useEffect } from 'react';

import { updateGlintsTrackingName } from '../../actions/meta';
import { useAppDispatch } from '../../store';
import useShowMobileAppPrompt from '../UseMobileAppPrompt/useShowMobileAppPrompt';
import TrackPageViewedEvent from './TrackPageViewedEvent';

function GlintsTrackingPageNameMeta(props: {
  glintsTrackingPageName: string | null;
}) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(updateGlintsTrackingName(props.glintsTrackingPageName));
  }, [dispatch, props.glintsTrackingPageName]);
  return null;
}

export function withGlintsTrackingPageNameMeta<P = Record<string, unknown>>(
  WrappedComponent: ComponentType<P>
) {
  const Wrapper = (props: P & JSX.IntrinsicAttributes) => {
    const desktopOnly = 'desktopOnly' in props && Boolean(props.desktopOnly);
    const glintsTrackingPageName =
      ('glintsTrackingPageName' in props &&
        (props.glintsTrackingPageName as string)) ||
      undefined;
    const trackPageView =
      !('trackPageView' in props) || props.trackPageView !== false;

    const isPromptShown = useShowMobileAppPrompt() && desktopOnly;

    if (!glintsTrackingPageName) {
      return (
        <>
          <GlintsTrackingPageNameMeta glintsTrackingPageName={null} />
          <WrappedComponent {...props} />
        </>
      );
    }

    // mobile app prompt is not a different route, our user case is to track it as a different page
    const pageName = isPromptShown
      ? 'download_mobile_app_prompt'
      : glintsTrackingPageName;
    const shouldTrackPageView = trackPageView || isPromptShown;

    return (
      <>
        <GlintsTrackingPageNameMeta glintsTrackingPageName={pageName} />
        {shouldTrackPageView && <TrackPageViewedEvent pageName={pageName} />}
        <WrappedComponent {...props} />
      </>
    );
  };

  return Wrapper;
}
